import { type FC, useState, useEffect } from 'react';

interface Props extends ClassNameProp {
  id: number;
}

const CSWeapon: FC<Props> = ({ id, className }) => {
  const [icon, setIcon] = useState<null | SVG>(null);

  useEffect(() => {
    import('app/icons/cs_weapons/weapons').then(({ default: weapons }) => {
      // Wrapped in a thunk: a bare component would be treated as a state updater
      // and called, storing the rendered element instead of the component.
      setIcon(() => weapons[id] ?? null);
    });
  }, [id]);

  if (!icon) return null;

  const Icon = icon;
  return <Icon className={className} />;
};

CSWeapon.displayName = 'CSWeapon';

export default CSWeapon;
